import React from 'react';

// Detects full URLs (http/https) and bare www. links inside plain text.
// Trailing punctuation that commonly follows a link — `)`, `]`, quotes and
// angle brackets — is excluded from the matched URL.
const URL_REGEX = /(https?:\/\/[^\s<>"'\])]+|www\.[^\s<>"'\])]+)/gi;

function isLink(text) {
  return /^(https?:\/\/|www\.)/i.test(text);
}

function toHref(text) {
  return /^www\./i.test(text) ? `https://${text}` : text;
}

// Renders a plain-text string into React nodes, converting URLs into safe
// clickable anchors (no dangerouslySetInnerHTML → XSS-safe by design).
export function linkify(text) {
  if (typeof text !== 'string' || !text) return text;
  return text.split(URL_REGEX).map((part, index) =>
    isLink(part) ? (
      <a
        key={index}
        href={toHref(part)}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 break-all"
      >
        {part}
      </a>
    ) : (
      part
    )
  );
}

export default function LinkifiedText({ text, className = '' }) {
  return <span className={className}>{linkify(text)}</span>;
}
